import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomViewsUpgradeLink = ({
  openUpgradeModal
}) => /*#__PURE__*/_jsxs(Button, {
  onClick: openUpgradeModal,
  "data-test-id": "upgrade-point-custom-view",
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.viewsSidebar.actions.createCustomView"
  }), /*#__PURE__*/_jsx(LockBadge, {})]
});
CustomViewsUpgradeLink.displayName = 'CustomViewsUpgradeLink';
export default CustomViewsUpgradeLink;